import moment from "moment";
import { useContext, useEffect, useMemo, useState } from "react";
import {
  PortalAdditionalReportGroupViewModel,
  PortalAdditionalReportViewModel,
} from "../../../generated/data-contracts";
import { IAxiosError, api } from "../../../utils";
import { AvisForm } from "../../shared/components";
import { AvisDescriptiveText } from "../../shared/components/form";
import { AvisContext } from "../../shared/context/AvisContext";
import { ErrorLoadingDataHoc } from "../../shared/error/ErrorLoadingDataHoc";
import { NoDataPage } from "../../shared/error/NoDataPage";
import { SelectedReportDetails } from "./reportDetails/SelectedReportDetails";
import { ReportsList } from "./reportsList/ReportsList";

export function ReportsPage() {
  const { res, ctxRightsHolder } = useContext(AvisContext);

  const [reports, setReports] = useState<
    PortalAdditionalReportGroupViewModel[] | undefined
  >();
  const [selectedReport, setSelectedReport] = useState<
    PortalAdditionalReportViewModel | undefined
  >();
  const [isReportsLoading, setIsReportsLoading] = useState<boolean>(true);
  const [error, setError] = useState<IAxiosError>();

  //Saving selected parameter values - shared between reports
  const [selectedReportParams, setSelectedReportParams] = useState<
    Record<string, string>
  >({
    Year: (moment().year() - 1).toFixed(), //default value for year parameter
  });

  const onParamChange = (pKey: string, pValue: string): void => {
    setSelectedReportParams((prevState) => {
      return {
        ...prevState,
        [pKey]: pValue,
      };
    });
  };
  const getData = useMemo(() => {
    if (!ctxRightsHolder?.rightsHolderId) return;
    setIsReportsLoading(true);

    api
      .reportsGetPortalAdditionalReports()
      .then((res) => setReports(res.data))
      .catch(setError)
      .finally(() => setIsReportsLoading(false));
  }, [ctxRightsHolder?.rightsHolderId]);

  useEffect(() => {
    getData;
  }, [ctxRightsHolder?.rightsHolderId, getData]);

  const renderSelectedReportDetails = () => {
    if (!selectedReport) return;

    return (
      <SelectedReportDetails
        selectedReport={selectedReport}
        onParamChange={onParamChange}
        selectedParams={selectedReportParams}
        key={selectedReport.relativeUrl}
      />
    );
  };
  const renderPage = () => {
    if (!reports) return <NoDataPage />;

    return (
      <div className="reports-page">
        <ReportsList
          reports={reports}
          selectedReport={selectedReport}
          setSelectedReport={setSelectedReport}
        />
        {renderSelectedReportDetails()}
      </div>
    );
  };

  return (
    <AvisForm title={res("authors_ReportsPage_Title")}>
      <AvisDescriptiveText textKey="portal_RH_Reports_1" />
      <ErrorLoadingDataHoc error={error} loading={isReportsLoading}>
        {renderPage()}
      </ErrorLoadingDataHoc>
    </AvisForm>
  );
}
